import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'components';

function Credit({ data }) {
  return (
    <Table textAlign="center" style={{ margin: '4rem 0 0 0' }}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Credit Rating</Table.HeaderCell>
          <Table.HeaderCell>Percentage of Portfolio</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>AAA</Table.Cell>
          <Table.Cell>{(data.credit_quality.aaa * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>AA</Table.Cell>
          <Table.Cell>{(data.credit_quality.aa * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>A</Table.Cell>
          <Table.Cell>{(data.credit_quality.a * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>BBB</Table.Cell>
          <Table.Cell>{(data.credit_quality.bbb * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>BB</Table.Cell>
          <Table.Cell>{(data.credit_quality.bb * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>B</Table.Cell>
          <Table.Cell>{(data.credit_quality.b * 100).toFixed(2)}%</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Below B</Table.Cell>
          <Table.Cell>
            {(data.credit_quality.below_b * 100).toFixed(2)}%
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Not Rated</Table.Cell>
          <Table.Cell>
            {(data.credit_quality.not_rated * 100).toFixed(2)}%
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

Credit.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Credit;
